module.exports = __webpack_public_path__ + "4cd2efd10b4783981ea3c253aa386695.MP3";